import React, { FC } from 'react';
import { ProductCategories as ProductCategoriesComponent } from '@raisin/components-lib';
import { getProductCategoryItems } from './utils';
import { ProductCategoryProps } from './types';

export const ProductCategories: FC<ProductCategoryProps> = ({ body_copies }) => {
  const productCategoryItems = getProductCategoryItems(body_copies);

  return productCategoryItems ? (
    <ProductCategoriesComponent productCategoryItems={productCategoryItems} />
  ) : null;
};
